export default __webpack_public_path__ + "static/media/vip2.7a83c71b.webp";